import { AspectRatio, Modal } from '@mantine/core';
import { useTranslation } from '@refinedev/core';

interface ReportPreviewModalProps {
  opened: boolean;
  previewUrl: string | null;
  onClose: () => void;
}

export const ReportPreviewModal = ({
  opened,
  previewUrl,
  onClose,
}: ReportPreviewModalProps) => {
  const { translate } = useTranslation();
  const title = translate(
    'common:notificationCenter.reportActions.previewTitle',
    'Report preview'
  );

  return (
    <Modal opened={opened} onClose={onClose} title={title} size="xl" centered>
      {previewUrl && (
        <AspectRatio ratio={1}>
          <iframe
            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0`}
            title={title}
            style={{ border: 'none' }}
          />
        </AspectRatio>
      )}
    </Modal>
  );
};
